import PropTypes from 'prop-types';
import React from 'react';
import { Panel } from 'react-bootstrap';
import { commissionType } from './CommissionPropTypes';
import CommissionBadge from './CommissionBadge';

class CommissionOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      needCalc: true,
      sum: { paid: 0, due: 0, pending: 0, overdue: 0 },
    };
  }
  componentDidMount() {
    if (this.state.needCalc) {
      this.updateStats(this.props.commissions);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.commissions !== this.props.commissions) {
      this.updateStats(nextProps.commissions);
    }
  }
  updateStats(commissions) {
    const sum = { paid: 0, due: 0, pending: 0, overdue: 0 };
    commissions.forEach((commission) => {
      const state = commission.state.toLowerCase();
      sum[state] += commission.value;
    });
    this.setState({
      needCalc: false,
      sum,
    });
  }
  renderLoading() {
    const spinner = (
      <div className="text-center">
        <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
        <span className="sr-only">Loading...</span>
      </div>
    );
    return (
      <div className="row">
        <div className="planner col-sm-12">
          <div className="col-sm-3">

            <Panel header="Overdue">
              { spinner }
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Due">
              { spinner }
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Pending">
              { spinner }
            </Panel>
          </div>
          <div className="col-sm-3">
            <Panel header="Paid">
              { spinner }
            </Panel>
          </div>
        </div>
      </div>
    );
  }
  render() {
    if (this.state.needCalc) {
      return this.renderLoading();
    }
    return (
      <div>
        <div className="row tour-head">
          <div className="col-md-12 tour-headText">
            <h2>Commissions</h2>
          </div>
        </div>
        <hr />
        <div className="row planner">
          <CommissionBadge
            title="Overdue"
            value={this.state.sum.overdue}
          />
          <CommissionBadge
            title="Due"
            value={this.state.sum.due}
          />
          <CommissionBadge
            title="Pending"
            value={this.state.sum.pending}
          />
          <CommissionBadge
            title="Paid"
            value={this.state.sum.paid}
          />
        </div>
      </div>
    );
  }
}

CommissionOverview.propTypes = {
  commissions: PropTypes.arrayOf(
    PropTypes.shape({ commissionType }),
  ).isRequired,
};
export default CommissionOverview;



// WEBPACK FOOTER //
// src/routes/commissions/components/CommissionOverview.js